import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "modal fade in",
  id: "ajaxModal",
  style: {
    "width": "100vw",
    "height": "100vh",
    "display": "flex",
    "background-color": "rgba(0, 0, 0, 0.7)",
    "opacity": "1",
    "justify-content": "center",
    "align-items": "center",
    "align-content": "center"
  }
};
const _hoisted_2 = {
  class: "modal-dialog",
  style: {
    "max-width": "600px",
    "min-width": "340px",
    "pointer-events": "unset",
    "transform": "none",
    "background-color": "#fff",
    "border-radius": "10px"
  }
};
const _hoisted_3 = {
  style: {
    "font-size": "40px",
    "background-color": "#fff",
    "border": "1px solid #777",
    "max-height": "72vh",
    "overflow-y": "auto",
    "border-radius": "10px"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  style: {
    "display": "flex",
    "justify-content": "space-around",
    "margin-top": "10px"
  }
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  style: {},
  class: "bi bi-check-circle-fill"
}, null, -1);

const _hoisted_7 = [_hoisted_6];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    innerHTML: $props.html
  }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
    onClickCapture: _cache[0] || (_cache[0] = $event => $options.closeModal()),
    style: {
      "height": "53px",
      "font-size": "36px",
      "color": "#000",
      "margin-bottom": "23px",
      "opacity": "0.5",
      "width": "100px",
      "border": "1px solid #000",
      "background-color": "#4fc7ff",
      "border-radius": "6px"
    },
    type: "button"
  }, _hoisted_7, 32)])])])])) : _createCommentVNode("", true);
}